import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_text",
  "use": "icon_text-usage",
  "viewBox": "0 0 18 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 24\" id=\"icon_text\"><path d=\"M764.5,3121h-16a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0v-2h6v20H753a1,1,0,0,0,0,2h7a1,1,0,0,0,0-2h-2.5v-20h6v2a1,1,0,0,0,2,0v-3A1,1,0,0,0,764.5,3121Z\" transform=\"translate(-747.5 -3121)\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol